import axios from 'axios';

const selectors = {
    errorMessage: '[data-footer-sms-error]',
    form: '[data-footer-sms-signup]',
    input: 'input[name="phone_number"]',
    submitButton: '.form-newsletter__submit',
    successMessage: '[data-footer-sms-success]',
};

const classes = {
    hidden: 'u-hide',
};

class FooterSmsSignup {
    /**
     * @param {HTMLFormElement} element
     */
    constructor(element) {
        this.element = element;
        this.phoneInput = this.element.querySelector(selectors.input);
        this.submitButton = this.element.querySelector(selectors.submitButton);
        this.errorMessageContainer = this.element.parentElement.querySelector(
            selectors.errorMessage
        );
        this.successMessageContainer = this.element.parentElement.querySelector(
            selectors.successMessage
        );

        this.registerEventListeners();
    }

    registerEventListeners() {
        this.element.addEventListener('submit', event => this.onSubmit(event));
    }

    clearMessages() {
        this.errorMessageContainer.textContent = '';
        this.errorMessageContainer.classList.add(classes.hidden);
        this.successMessageContainer.textContent = '';
        this.successMessageContainer.classList.add(classes.hidden);
    }

    normalizePhoneNumber(phoneNumber) {
        return phoneNumber.trim().replace(/\s+/g, '');
    }

    isValidPhoneNumber(phoneNumber) {
        return /^\+[1-9]\d{7,14}$/.test(phoneNumber);
    }

    showError(message) {
        this.errorMessageContainer.textContent = message;
        this.errorMessageContainer.classList.remove(classes.hidden);
    }

    showSuccess(message) {
        this.successMessageContainer.textContent = message;
        this.successMessageContainer.classList.remove(classes.hidden);
    }

    /**
     * @param {SubmitEvent} event
     */
    onSubmit(event) {
        event.preventDefault();

        const companyId = this.element.dataset.klaviyoCompanyId;
        const customerEmail = this.element.dataset.customerEmail;
        const customerFirstName = this.element.dataset.customerFirstName;
        const customerLastName = this.element.dataset.customerLastName;
        const customerAddress1 = this.element.dataset.customerAddress1;
        const customerAddress2 = this.element.dataset.customerAddress2;
        const customerCity = this.element.dataset.customerCity;
        const customerRegion = this.element.dataset.customerRegion;
        const customerZip = this.element.dataset.customerZip;
        const customerCountry = this.element.dataset.customerCountry;
        const listId = this.element.dataset.klaviyoListId;
        const phoneNumber = this.normalizePhoneNumber(this.phoneInput.value);
        const invalidMessage = this.element.dataset.smsInvalidMessage;
        const errorMessage = this.element.dataset.smsErrorMessage;
        const successMessage = this.element.dataset.smsSuccessMessage;
        const location = {};
        const profileAttributes = {
            phone_number: phoneNumber,
            subscriptions: {
                sms: {
                    marketing: {
                        consent: 'SUBSCRIBED',
                    },
                },
            },
        };

        this.clearMessages();

        if (!companyId || !listId) {
            this.showError(errorMessage);
            console.error('Missing Klaviyo SMS signup configuration.', {
                companyId,
                listId,
            });
            return;
        }

        if (!this.isValidPhoneNumber(phoneNumber)) {
            this.showError(invalidMessage);
            return;
        }

        if (customerEmail) profileAttributes.email = customerEmail;
        if (customerFirstName) profileAttributes.first_name = customerFirstName;
        if (customerLastName) profileAttributes.last_name = customerLastName;
        if (customerAddress1) location.address1 = customerAddress1;
        if (customerAddress2) location.address2 = customerAddress2;
        if (customerCity) location.city = customerCity;
        if (customerRegion) location.region = customerRegion;
        if (customerZip) location.zip = customerZip;
        if (customerCountry) location.country = customerCountry;
        if (Object.keys(location).length) profileAttributes.location = location;

        this.phoneInput.value = phoneNumber;
        this.submitButton.disabled = true;

        axios({
            url: `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                revision: '2026-04-15',
            },
            data: {
                data: {
                    type: 'subscription',
                    attributes: {
                        custom_source: 'footer_sms_signup',
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: profileAttributes,
                            },
                        },
                    },
                    relationships: {
                        list: {
                            data: {
                                type: 'list',
                                id: listId,
                            },
                        },
                    },
                },
            },
        })
            .then(() => {
                this.element.classList.add(classes.hidden);
                this.showSuccess(successMessage);
            })
            .catch(error => {
                if (error.response) {
                    console.error('Footer SMS signup response data:', error.response.data);
                    console.error('Footer SMS signup response status:', error.response.status);
                    console.error('Footer SMS signup response headers:', error.response.headers);
                } else if (error.request) {
                    console.error('Footer SMS signup request:', error.request);
                } else {
                    console.error('Footer SMS signup error:', error.message);
                }

                this.submitButton.disabled = false;
                this.showError(errorMessage);
            });
    }
}

const forms = document.querySelectorAll(selectors.form);

if (forms.length) {
    forms.forEach(form => {
        new FooterSmsSignup(form);
    });
}

export default FooterSmsSignup;
